import { render, staticRenderFns } from "./FormPregrado.vue?vue&type=template&id=1348c0da&"
import script from "./FormPregrado.vue?vue&type=script&lang=js&"
export * from "./FormPregrado.vue?vue&type=script&lang=js&"
import style0 from "./FormPregrado.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports